export default "__VITE_ASSET__Bp_R3yT0__"